import { gql } from "graphql-request"
import { appId } from "../constant/Constants";
import { NonTokenGraphql } from "./Graphql"

export const genAppToken = async () => {
  const GEN_APP_TOKEN = gql`
  mutation GenTokenApp($data: TokenAppCreateInput!) {
    GenTokenApp(data: $data) {
      appId
      expiredAt
      id
      platform
      role
      token
      type
    }
  }
  `

  const response = await NonTokenGraphql.request(GEN_APP_TOKEN, appId);
  return response.GenTokenApp;
} 